/** biome-ignore-all lint/suspicious/noEmptyBlockStatements: <explanation> */
import { CommonPriceElementGroup } from 'common/components/entities/price-element/price-element-group'
import {
  PriceElementGroupInterface,
  PriceElementPeriodInterface,
} from 'common/components/entities/price-element/price-element-interface'
import { CommonPriceElementPeriod } from 'common/components/entities/price-element/price-element-period'
import { CommonPriceElementPlans } from 'common/components/entities/price-element/price-element-plans'
import {
  CommonPriceElementContainerUi,
  CommonPriceElementPlansWrapperUi,
  CommonPriceElementTableContainerUi,
  CommonPriceElementWrapperUi,
} from 'common/components/entities/price-element/ui'
import {
  getDefaultPricePeriod,
  getPriceGroupDefault,
} from 'common/components/entities/price-element/utils'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'

interface PriceElementSkeletonProps {
  locale: PageLocaleEnum
  t: TFunction
}

export const PriceElementSkeleton = ({
  locale = PageLocaleEnum.ENGLISH,
  t,
}: PriceElementSkeletonProps) => {
  const pricePeriod: PriceElementPeriodInterface[] = getDefaultPricePeriod(
    4,
    'monthly',
  )
  const priceGroup: PriceElementGroupInterface[] = getPriceGroupDefault()

  return (
    <CommonPriceElementWrapperUi>
      <CommonPriceElementContainerUi>
        <CommonPriceElementPlansWrapperUi>
          <CommonPriceElementPeriod
            locale={locale}
            activeBtn={'monthly'}
            onClick={() => {}}
            t={t}
            isLoading
          />
          <CommonPriceElementPlans
            locale={locale}
            plans={pricePeriod}
            activeBtn={'monthly'}
            onClick={() => {}}
            t={t}
            isLoading
          />
        </CommonPriceElementPlansWrapperUi>
        <CommonPriceElementTableContainerUi>
          {priceGroup.map(el => (
            <CommonPriceElementGroup
              key={el.id}
              pricePeriod={pricePeriod}
              locale={locale}
              data={el}
              t={t}
              isLoading
            />
          ))}
        </CommonPriceElementTableContainerUi>
      </CommonPriceElementContainerUi>
    </CommonPriceElementWrapperUi>
  )
}
